import ArtistProfileFull from "../components/ArtistProfileFull";
import ArtistProfileMobile from "../components/ArtistProfileMobile";
import { useMediaQuery } from "@mui/material";

export default function Artists() {
    const mobileDevice = useMediaQuery('(max-width:1025px)');
    return (
        mobileDevice ? <ArtistProfileMobile /> : <ArtistProfileFull />
    )
};
